import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="page-payment-cancel" className="min-h-screen bg-[#FCEFE2] flex items-center justify-center px-5">
      <div className="max-w-md w-full bg-white rounded-[1.75rem] border border-[#F7E6D2] p-10 text-center shadow-[0_30px_60px_-40px_rgba(69,40,26,0.25)]">
        <XCircle size={44} strokeWidth={1.2} className="text-[#A08064] mx-auto" />
        <h1 className="font-serif text-3xl text-[#2E1A10] mt-6">Zahlung abgebrochen</h1>
        <p className="text-[#6F4B34] mt-4 leading-relaxed text-[15px]">
          Kein Problem – es wurde nichts abgebucht. Du kannst es jederzeit erneut
          versuchen oder mir erst eine Nachricht schreiben.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
          <Link
            to="/"
            data-testid="payment-cancel-home"
            className="btn-ghost rounded-full px-8 py-3 text-sm font-medium"
          >
            Zurück zur Startseite
          </Link>
          <a
            href="/#kontakt"
            data-testid="payment-cancel-contact"
            className="btn-primary rounded-full px-8 py-3 text-sm font-medium inline-block"
          >
            Kontakt aufnehmen
          </a>
        </div>
      </div>
    </div>
  );
}
